import ErrorBox from '@components/common/ErrorBox';
import debounce from '@mui/material/utils/debounce';
import { AccordionStepsActionTypes, AftercareActionTypes } from '@state/features/common.types';
import Button from '@ui/button/Button';
import DwFormField from '@ui/formfield/DwFormField';
import analytics from '@utils/analytics';
import api from '@utils/api';
import formutils from '@utils/formutils';
import createDecorator from 'final-form-focus';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
const focusOnError = createDecorator();
const AftercareStep2 = (props) => {
    const { t } = useTranslation();
    const [formdef, setFormdef] = useState();
    const [initialValues, setInitialValues] = useState();
    const [errors, setErrors] = React.useState([]);
    const dispatch = useDispatch();
    useEffect(() => {
        let val = {};
        api.getForm('aftercare-service', val).then((data) => {
            setInitialValues(val);
            setFormdef(data);
        });
    }, []);
    const onSubmit = async (values) => {
        setErrors([]);
        let errors = await validate(values);
        if (errors && Object.keys(errors).length > 0) {
            return errors;
        }
        return api
            .aftercareStep2(values, formdef)
            .then((data) => {
            if (data.success) {
                dispatch({
                    type: AftercareActionTypes.UPDATE_AFTERCARE,
                    payload: values,
                });
                dispatch({
                    type: AccordionStepsActionTypes.NAVIGATE_STEP,
                    payload: 'product',
                });
            }
            if (data.error && data.error.length > 0) {
                setErrors(data.error);
            }
            if (!formutils.checkValidationAfterSubmit(data, errors)) {
                return errors;
            }
            analytics.aftercareTwo();
        })
            .catch((e) => setErrors([e]));
    };
    const handleGoBack = () => {
        dispatch({
            type: AccordionStepsActionTypes.NAVIGATE_STEP,
            payload: 'customer',
        });
        analytics.aftercareBackEdit('service required', 'back');
    };
    const validate = async (values) => {
        return await formutils.validateForm(values, formdef, 'aftercare-service');
    };
    if (!formdef) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "aftercare__form" },
        React.createElement("div", { className: "aftercare__form__step-description" }, t('aftercare.selectservice')),
        React.createElement(Form, { onSubmit: onSubmit, validate: debounce(validate, 300), decorators: [focusOnError], initialValues: initialValues, render: ({ handleSubmit, form, submitting, pristine, values }) => (React.createElement("form", { onSubmit: handleSubmit },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-12" },
                        React.createElement(DwFormField, { def: formdef, name: "service", type: "radio", groupClassName: "form-group--cols" }))),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-12" },
                        React.createElement(DwFormField, { def: formdef, name: "details", type: "textarea", helperText: t('aftercare.pleasenote') }))),
                React.createElement(ErrorBox, { errors: errors }),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-sm-6 d-none d-sm-flex " },
                        React.createElement(Button, { type: "button", cls: ['button--tertiary', 'button--arrow-left'], onClick: handleGoBack }, t('button.back'))),
                    React.createElement("div", { className: "col-sm-6" },
                        React.createElement(Button, { type: "submit", disabled: submitting, cls: ['button--primary'] }, t('aftercare.proceedtoproductidentification')))))) })));
};
export default AftercareStep2;
